import { motion } from "framer-motion";

// Cinematic but compact page header used on every inner page.
export const PageHero = ({ eyebrow, title, italic, subtitle, image, align = "left" }) => {
  return (
    <section className="relative pt-28 lg:pt-36 pb-16 lg:pb-24 bg-ink text-paper overflow-hidden">
      {image && (
        <div className="absolute inset-0">
          <img src={image} alt="" className="h-full w-full object-cover opacity-30" />
          <div className="absolute inset-0 bg-gradient-to-b from-ink/70 via-ink/55 to-ink" />
        </div>
      )}
      <div className="absolute inset-0 grain pointer-events-none" />

      <div className="relative mx-auto max-w-[1400px] px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className={align === "center" ? "max-w-3xl mx-auto text-center" : "max-w-3xl"}
        >
          <div className="flex items-center gap-3 mb-5">
            <span className="h-px w-10 bg-primary-glow" />
            <span className="mono text-[11px] uppercase tracking-[0.25em] text-primary-glow">
              {eyebrow}
            </span>
          </div>
          <h1 className="font-display text-[clamp(2.5rem,6.5vw,6rem)] leading-[0.95] tracking-[-0.03em] text-paper text-balance">
            {title}
            {italic && (
              <>
                <br />
                <em className="font-light text-paper/75">{italic}</em>
              </>
            )}
          </h1>
          {subtitle && (
            <p className="mt-7 text-base lg:text-lg text-paper/75 max-w-2xl leading-relaxed">
              {subtitle}
            </p>
          )}
        </motion.div>
      </div>
    </section>
  );
};
